import { useEffect, useRef } from 'react'
// Vite emits the emoji data as a hashed asset in our own bundle and hands back
// its URL, so the picker never fetches from a third-party CDN (its default).
// ~440 KB raw (much smaller gzipped), fetched once when a picker first opens
// and then cached in IndexedDB by the picker itself.
import emojiDataURL from 'emoji-picker-element-data/en/emojibase/data.json?url'
import './EmojiPickerPanel.css'

// The full emoji picker (emoji-picker-element, Apache-2.0): every current emoji,
// search by name and keyword ("taco", "party", "thumbs"), categories, recently
// used and skin tones. Emoji draw in the device's own emoji font, so they look
// exactly as they do in iMessage, and ones the device can't draw are hidden.
//
// It's a web component; this wraps it for React. The library is loaded on
// first open (dynamic import), not with the app. Shared by the reaction menu's
// "＋" and the composer's 😀 button.
export function EmojiPickerPanel({
  onPick,
  className,
}: {
  onPick: (emoji: string) => void
  className?: string
}) {
  const hostRef = useRef<HTMLDivElement>(null)
  // Latest callback without re-creating the picker on every render.
  const onPickRef = useRef(onPick)
  onPickRef.current = onPick

  useEffect(() => {
    let picker: HTMLElement | null = null
    let cancelled = false
    const handleClick = (e: Event) => {
      const unicode = (e as CustomEvent<{ unicode?: string }>).detail?.unicode
      if (unicode) onPickRef.current(unicode)
    }
    void import('emoji-picker-element').then(({ Picker }) => {
      if (cancelled || !hostRef.current) return
      picker = new Picker({ dataSource: emojiDataURL, locale: 'en' })
      picker.addEventListener('emoji-click', handleClick)
      hostRef.current.appendChild(picker)
    })
    return () => {
      cancelled = true
      if (picker) {
        picker.removeEventListener('emoji-click', handleClick)
        picker.remove()
      }
    }
  }, [])

  return <div ref={hostRef} className={`emoji-panel${className ? ` ${className}` : ''}`} />
}
